import { JSX } from 'react/jsx-runtime';
import { AuthGuard } from 'src/guards/auth-guard';

export const withAuthGuard = (Component: any) => (props: JSX.IntrinsicAttributes) => (
  <AuthGuard>
    <Component {...props} />
  </AuthGuard>
);
